import React, { useEffect, useState } from 'react';
import { push } from 'connected-react-router';
import { useDispatch } from 'react-redux';
import { FullAccount } from '../../../redux/Account/account.selectors';
import { App } from '../../../App';
import { FullLibraries } from '../../modules/Library/redux/library.selectors';
import { TopLevelNavigation } from '../Dashboard/TopLevelNavigation';
import { Role } from '../../../redux/Auth/auth.selectors';
import { useMyPermissions } from '../../modules/Permission/redux/permissions.actions';
import { Surface } from '../../../styles/Containers';
import { AssetsList } from '../../modules/Assets/AssetsList';




export const PageSearch = () => {

    const dispatch = useDispatch();
    const fullAccount = FullAccount();
    const currentUserRole = Role();
    const [noAccess, setNoAccess] = useState(true);
    const [filters, setFilters] = useState(null);
    const { permissions, hasPermission, getPermissionRole, permissionChecked } = useMyPermissions();


    useEffect(() => {
        if (currentUserRole !== 'owner' && currentUserRole !== 'admin') {
            if (permissions?.length > 0) {
                const libs = permissions.filter(l => (l.modelType === 'Library'));
                let form = libs.map(l => `"${l.modelId}"`).join(',')
                const args = { Library: `[${form}]` }
                setFilters(args);
                setNoAccess(false);
            }
        } else {
            setFilters({ Library: [] });
            setNoAccess(false);
        }

    }, [permissions])


    // --------------------------
    // Interactions
    // --------------------------

    const handleSelect = (item) => {

        dispatch(push(`/asset/${item.id}`))
    }

    const renderPageNavigation = () => {
        return (<TopLevelNavigation />)
    }



    return (
        <App pageNavigation={renderPageNavigation}>

            {!noAccess && (<AssetsList onSelect={handleSelect} filters={filters} myRole={currentUserRole} sortByKey="searchSortAssets" filterByDateKey="searchFilterByDateAssets" filterByTypeKey="searchFilterByTypeAssets" />)}


        </App>
    )
}